import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetch() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    return axios.post('', {
      query: `
        query {
          permissions {
            id,
            name,
            display_name,
            description,
            category {
              name,
              description,
            }
          }
        }
      `
    })
  }
}
